export default function downame(value) {
    return value.substring(0,3).toUpperCase();
}